import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';
import { User } from '@models/User';

export type AuthOtpTokenGenerateParams = WithParams<{
  mobile_number: string;
}>;

type AuthOtpTokenResponse = WithParams<{
  otp_token: string;
}>;

export type AuthOtpTokenPasswordUpdateParams = WithParams<{
  password: string;
  password_confirmation: string;
  otp_token: string;
}>;

export type AuthOtpTokenGetUserParams = AuthOtpTokenResponse;

export class OtpApi {
  static get = async (params: AuthOtpTokenGetUserParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/auth/otp_link`, { params: snakes(params) })
      .then((response) => humps(response.data) as User);
  };

  static generateOtpToken = async (params: AuthOtpTokenGenerateParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/auth/otp_link`, snakes(params))
      .then((response) => humps(response.data) as AuthOtpTokenResponse);
  };

  static updatePassword = async (params: AuthOtpTokenPasswordUpdateParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/auth/otp_link/password`, snakes(params))
      .then((response) => humps(response.data) as { errorMessage: string });
  };
}
